import React from 'react';
import { AnswerFieldProps } from './QuestionField';
import negative from 'images/smiley_neg.png';
import positive from 'images/smiley_pos.png';

export const QuestionSlider = (props: AnswerFieldProps) => {
	function valueChanged(newValue?: number) {
		if (newValue !== undefined && newValue !== props.currentValue) {
			props.valueChanged?.(newValue);
		}
	}

	return (
		<div className='slider'>

			{
				props.title &&
				<label htmlFor={`${props.idPrefix}_slider`} className='slider-title'>{props.title}</label>
			}
			<div className='slider-img-row'>
				<img src={negative} className='slider-end-img' alt='negatiivinen vastaus' />


				<input type='range'  readOnly={props.disabled}
					disabled={props.disabled}
					value={props.currentValue !== undefined ? props.currentValue : 50}
					min={props.answerValue.values[0].value}
					max={props.answerValue.values[1].value}
					onChange={(evt) => valueChanged(parseInt(evt.currentTarget.value))}
					onFocus={(evt) => valueChanged(parseInt(evt.currentTarget.value))}
					step='1'
					id={`${props.idPrefix}_slider`}
					aria-valuemin={props.answerValue.values[0].value}
					aria-valuemax={props.answerValue.values[1].value}
					aria-valuenow={props.currentValue} />

				<img src={positive} className='slider-end-img' alt='positiivinen vastaus' />
			</div>
			<div className='center-piece' />
			<div className='slider-labels'>
				<p>{props.answerValue.values[0].text}</p>
				<p className='align-end'>{props.answerValue.values[1].text}</p>
			</div>
		</div>
	);
}
